interface Props {
  listenToResize?: boolean;
}
export const useMaxHeightAnimator = (props: Props) => {
  const listenToResize = props.listenToResize === true;

  const id = useId();
  const animatedElementRootClass = `animate-height-${id}`;
  const animatedElementTransitionClasses =
    'transition-[max-height] duration-300';

  const setElementHeightCallback = async () => {
    if (!import.meta.client) {
      return;
    }

    await nextTick();
    const tableElListByClass = document.getElementsByClassName(
      animatedElementRootClass,
    ) as HTMLCollectionOf<HTMLElement>;
    if (!tableElListByClass || tableElListByClass.length === 0) {
      return;
    }

    const tableEl = tableElListByClass.item(0);
    if (!tableEl) {
      return;
    }

    const newHeight = tableEl.scrollHeight;
    if (newHeight === undefined || newHeight === null) {
      return;
    }

    tableEl.style.maxHeight = `${newHeight}px`;
  };

  onMounted(() => {
    setElementHeightCallback();

    if (listenToResize) {
      useEventListener('resize', () => {
        setElementHeightCallback();
      });
    }
  });

  return {
    animatedElementRootClass,
    animatedElementTransitionClasses,
    setElementHeightCallback,
  };
};
